import React from 'react';


const {
    Provider: ListDesignerProvider,
    Consumer: ListDesignerConsumer
} = React.createContext();

export {
    ListDesignerConsumer,
    ListDesignerProvider
};